import React, {useEffect, useState, useMemo, useCallback} from "react";
import _, {find} from "lodash";
import {useDispatch, useSelector} from 'react-redux';
import {useDropzone} from 'react-dropzone'
import {Link} from "react-router-dom";

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {makeStyles} from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import {getPortfolio, sendDeals, updateImport, updateUserPortfolio} from "../store/actions";
import Service from "../services/Service";
import Tinkoff_API from "./Tinkoff_API";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from '@material-ui/lab/Alert';
import Grid from '@mui/material/Grid';
import {currencies} from "../AppConstants";
import Typography from '@material-ui/core/Typography';
import Chip from "@mui/material/Chip";

const Alert = (props) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const MIMES = {
    '.xlsx': ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    '.xls': ['application/vnd.sealed.xls', 'application/vnd.ms-excel'],
    '.html': ['text/html'],
    '.htm': ['text/html'],
    '.xml': ['text/xml'],
    '.csv': ['text/csv'],
    '.json': ['application/json'],
    '': ['text/*', 'application/*', 'image/*']
}

const typeList = [
    {
        name: 'Тинькофф',
        type: 'tink',
        extentions: ['.xlsx'],
    },
    {
        name: 'Сбербанк',
        type: 'sbol',
        extentions: ['.xlsx','.html','.htm', '.xls'],
    },
    {
        name: 'Газпромбанк',
        type: 'gpb-quik',
        extentions: ['.htm', '.xls'],
    },
    {
        name: 'ВТБ',
        type: 'vtb',
        extentions: ['.xls','.htm', '.xls'],
    },
    {
        name: 'Альфа банк',
        type: 'alpha',
        extentions: ['.xls'],
    },
    {
        name: 'БКС',
        type: 'bks',
        extentions: ['.xls'],
    },
    {
        name: 'Финам',
        type: 'finam',
        extentions: ['.xls', '.xlsx', '.xml', '.htm', '.html'],
    },
    {
        name: 'Открытие',
        type: 'otkr',
        extentions: ['.xlsx'],
    },
    {
        name: 'Промсвязьбанк',
        type: 'psb',
        extentions: ['.xlsx'],
    },
    {
        name: 'Атон',
        type: 'aton',
        extentions: ['.xls'],
    },
    {
        name: 'КИТ Финанс',
        type: 'kit',
        extentions: ['.xlsx'],
    },
    {
        name: 'Уралсиб',
        type: 'uralsib',
        extentions: ['.xls','.htm', '.xls'],
    },
    {
        name: 'Азиатско-Тихоокеанский Банк',
        type: 'atb',
        extentions: ['.xls'],
    },
    {
        name: 'Interactive Brokers',
        type: 'ib',
        extentions: ['.csv'],
    },
    {
        name: 'Фридом Финанс',
        type: 'ff',
        extentions: ['.xml', '.xlsx', '.json'],
    },
    {
        name: 'АЛОР брокер',
        type: 'alor',
        extentions: ['.xml'],
    },
    {
        name: 'ITI Capital',
        type: 'iti',
        extentions: ['.xlsx'],
    },
    {
        name: 'Saxo Bank',
        type: 'saxo',
        extentions: ['.xlsx'],
    },
    {
        name: 'РоссельзозБанк',
        type: 'rshb',
        extentions: ['.xls', '.xlsx'],
    },
    {
        name: 'Cap Trader',
        type: 'cap',
        extentions: ['.csv'],
    },
    {
        name: 'Intelinvest - экспорт сделок',
        type: 'intel',
        extentions: ['.xlsx'],
    },
    {
        name: 'BlackTerminal - экспорт сделок',
        type: 'black',
        extentions: ['.xls', '.json'],
    },
    {
        name: 'Wealth Adviser - экспорт сделок',
        type: 'wa',
        extentions: ['.csv'],
    },
    {
        name: 'DriveWealth - экспорт сделок',
        type: 'dw',
        extentions: ['.xls'],
    }
]

const useStyles = makeStyles((theme) => ({
    textContainer: {
        margin: '1em, 0',
        padding: '10px'
    },

    reportList: {
        position: 'relative',
        'background-color': '#0B1426',
        color: '#fff',
        margin: '10px 0',
        borderRadius: 12,
    },

    baseStyle: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        borderWidth: 2,
        borderRadius: 16,
        borderColor: '#E8ECF2',
        borderStyle: 'dashed',
        backgroundColor: '#F4F6FA',
        color: '#bdbdbd',
        outline: 'none',
        margin: '50px 0',
        transition: 'border .24s ease-in-out'
    },

    activeStyle: {
        borderColor: '#3B82F6'
    },

    acceptStyle: {
        borderColor: '#10B981'
    },

    rejectStyle: {
        borderColor: '#EF4444'
    }

}));

const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '30px',
    borderWidth: 2,
    borderRadius: 16,
    borderColor: '#E8ECF2',
    borderStyle: 'dashed',
    backgroundColor: '#F4F6FA',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .5s ease-in-out',
    margin: '50px 0'
};

const acceptStyle = {
    borderColor: '#10B981'
};

const rejectStyle = {
    borderColor: '#EF4444'
};

const activeStyle = {
    borderColor: '#3B82F6'
};



export default function () {
    const service = new Service();
    const data = useSelector(store => store.portfolio?.data)



    const [openAlert, setOpenAlert] = useState(false);
    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };
    const dispatch = useDispatch();
    const classes = useStyles();
    const portfolioList = useSelector(store => store.portfolios?.list);
    const selectedIndex = useSelector(store => store.user.portfolio);
    //const import_tag = useSelector(store => store.import.isLoad)
    const portfolio = portfolioList[selectedIndex] || undefined

    const isLoadind = useSelector(store => store.import?.isLoad)

    const [currentType, setCurrentType] = useState(null);
    const [currentMIMES, setCurrentMIMES] = useState('');
    const [menuTypeOpen, setMenuTypeOpen] = useState(false);


    const handleClickListItem = (event) => {
        setMenuTypeOpen(true);
    };

    const handleMenuItemClick = (event, index, option) => {
        setCurrentType(option);
        setMenuTypeOpen(false);
    };

    const handleClose = () => {
        setMenuTypeOpen(false);
    };


    async function fileExtractor(event) {
        const files = [];
        const fileList = event.dataTransfer ? event.dataTransfer.files : event.target.files;

        for (var i = 0; i < fileList.length; i++) {
            const file = fileList.item(i);

            Object.defineProperty(file, 'myProp', {
                value: true
            });

            files.push(file);
        }

        console.log('extract', files);
        return files;
    }

    const fileValidatorMIME = (file) => {
        const mime = _.last(file.name.split('.'));

        if (currentType?.extentions && !_.includes(currentType?.extentions, `.${mime}`)) {
            return {
                code: "type-not-supported",
                message: `Type is not supported`
            };
        }

        return null
    }

    const onDrop2 = useCallback((files) => {
        let data = new FormData();

        files.forEach((file) => {
            const reader = new FileReader()

            reader.onabort = () => console.log('file reading was aborted')
            reader.onerror = () => console.log('file reading has failed')
            reader.onload = () => {
                // Do whatever you want with the file contents
                const binaryStr = reader.result
                data.append('file', binaryStr);
                console.log(binaryStr)
            }
            reader.readAsArrayBuffer(file)
        })

        dispatch(sendDeals({portfolio: portfolio?.id, parser_type: currentType?.type, 'f[]': data}));

    }, [])

    const onDrop = (files) => {

        if(currentType?.type) {
            console.log('add files', files)

            let data = new FormData();

            for (let i = 0; i < files.length; i += 1) {
                data.append('f[]', files[i], files[i].name);
            }
            data.append('portfolio', portfolio?.id);
            data.append('parser_type', currentType?.type);

            dispatch(sendDeals(data));
        }
        else {
            setOpenAlert(true);
        }
    }

    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject,
        open,
        acceptedFiles,
        fileRejections
    } = useDropzone({
        accept: currentMIMES,
        noClick: true,
        noKeyboard: true,
        noDragEventsBubbling: true,
        // getFilesFromEvent: event => fileExtractor(event),
        // onDrop: files => console.log('drop', files),
        onDrop,
        validator: fileValidatorMIME
    });

    const style = useMemo(() => ({
        ...baseStyle || {},
        ...(isDragActive ? activeStyle : {}),
        ...(isDragReject ? rejectStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
    }), [
        isDragActive,
        isDragReject,
        isDragAccept
    ]);


    useEffect(() => {
        console.log('effect', acceptedFiles)

        const data = new FormData();

        for (let i = 0; i < acceptedFiles.length; i += 1) {
            data.append('file', acceptedFiles[i]);
        }
        // dispatch(sendDeals({portfolio: portfolio?.id, parser_type: currentType?.type, 'f[]': data}));

    },[acceptedFiles]);
    // debugger
    // if (data?.imports){
    //     const t = find(typeList, x => x.type === data?.imports[data.imports.length - 1]?.parser)
    //     if(t){
    //         setCurrentType(t)
    //     }
    // }
    useEffect(() => {
        if (data?.imports){
            const t = find(typeList, x => x.type === data?.imports[data.imports.length - 1]?.broker)
            if(t){
                setCurrentType(t)
            }
        }
        // dispatch(sendDeals({portfolio: portfolio?.id, parser_type: currentType?.type, 'f[]': data}));

    },[data?.imports]);

    useEffect(() => {
        if(!isLoadind){
            dispatch(getPortfolio(portfolio?.id));
            // dispatch(updateImport(false))
        }
    }, [isLoadind])

    useEffect(() => {
        setCurrentMIMES(
            `${
                _.join(
                    _.map(
                        currentType?.extentions || [''],
                        (ext) => MIMES[ext || '']
                    ),
                    ', ')
            }`
        )
    }, [currentType]);

    return (
        <div>
            <Grid className={classes.reportList} xs={12} sm={6} md={4}>
                {!_.isEmpty(typeList) &&
                <>
                    <List component="nav" aria-label="Device settings">
                        <ListItem
                            button
                            aria-haspopup="true"
                            aria-controls="type-menu"
                            aria-label="when device is locked"
                            onClick={handleClickListItem}
                        >
                            <ListItemText primary={currentType?.name || 'Выберите брокера'}/><ExpandMoreIcon/>
                        </ListItem>
                    </List>

                    <Menu
                        id="type-menu"
                        anchorEl={Link}
                        keepMounted
                        open={menuTypeOpen}
                        onClose={handleClose}
                    >
                        {typeList.map((option, index) => (
                            <MenuItem
                                key={index}
                                disabled={option.type === currentType?.type}
                                selected={option.type === currentType?.type}
                                divider={option?.group}
                                onClick={(event) => handleMenuItemClick(event, index, option)}
                            >
                                <ListItemText>{option.name}</ListItemText>
                                {option.type == "tink" &&
                                    <Chip label="API" color="primary" variant="outlined" size="small"/>

                                }
                            </MenuItem>
                        ))}
                    </Menu>
                </>
                }
            </Grid>
            {/*<pre>{JSON.stringify(data?.imports[0].parser, null, 4)}</pre>*/}
            {currentType?.type=="tink" &&
            <Grid xs={12} sm={6} md={4}>
            <Tinkoff_API/>
            </Grid>
            }
            <div className="container">
                <div {...getRootProps({style})}>
                    <input {...getInputProps()} />

                    <Typography variant="body1">
                        <b>Загрузить отчет по сделкам</b>
                        </Typography>
                    <Typography variant="body1" className={classes.textContainer}>
                        {`Допустимые расширения ${_.join(currentType?.extentions || ['*'], ',')}`}
                    </Typography>

                    {isLoadind &&
                    <div style={{display: 'flex', justifyContent: 'center', background: 'rgba(255,255,255,.7)'}}>
                        <CircularProgress/>
                    </div>
                    }

                    {!isDragActive && !isLoadind &&(
                        <Typography variant="body1" className={classes.textContainer}>
                            {`Перетащить сюда или `}
                            <Link type="button" onClick={open}>
                                выбрать
                            </Link>
                        </Typography>
                    )}

                    {isDragAccept && !isLoadind && (
                        <p className={classes.textContainer}>All files will be accepted</p>
                    )}

                    {isDragReject && !isLoadind && (
                        <p className={classes.textContainer}>Some files will be ignored</p>
                    )}
                </div>
            </div>
            <Snackbar open={openAlert} autoHideDuration={5000} onClose={handleCloseAlert}>
                <Alert onClose={handleCloseAlert} severity="info">
                    Сначала выберите брокера
                </Alert>
            </Snackbar>
        </div>
    );
}

